<template>
    <console-layout width="100%" max-width="1024">

        <console-title>
            <span v-if="$route.params._ip">IP 상세</span>
            <span v-else>IP 생성</span>
        </console-title>

        <console-body>
            <v-card>
                <v-card-title class="subtitle-2">IP정보</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="whiteIp.name" label="이름" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="whiteIp.ip" label="IPv4 address" :disabled="!$hasScope(['root', 'admin'])" placeholder="예) 127.0.0.1" :rules="rules" persistent-placeholder></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="whiteIp.phone" label="연락처" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="whiteIp.reason" label="사유" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions />
            </v-card>
    
            <v-card class="mt-4">
                <v-card-title class="subtitle-2 font-weight-bold">관리자 메모</v-card-title>
                <v-card-text>
                    <v-textarea v-model="whiteIp.note" :disabled="!$hasScope(['root', 'admin'])" outlined hide-details rows="2" />
                </v-card-text>
            </v-card>
        </console-body>

        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto">
                <v-btn color="primary" :disabled="!$hasScope(['root', 'admin'])" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        VPasswordField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            whiteIp: {
                ip: null,
                name: null,
                code: "white",
                phone: null,
                reason: null,
                note: null
            },

            rules: [value => this.ValidateIPaddress(value) || "올바른 IP를 입력 하세요"]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.$route.params._ip){
                let { ipitem } = await api.console.ip.get({ _id: this.$route.params._ip });
                this.whiteIp = {
                    ...this.whiteIp,
                    ...ipitem
                };
            }
        },

        async save(){
            this.whiteIp._id
            ? await api.console.ip.put({
                ...this.whiteIp
            })
            : await api.console.ip.post({
                ...this.whiteIp
            });

            alert("저장되었습니다");
            this.$router.push(`/console/whitelist`);
        }, 
        ValidateIPaddress(value) {  
            let ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            if(ipformat.test(value)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>